import { firestoreInstance } from 'config/ApiService';
import { doc, getDoc } from 'firebase/firestore';

export type PdfHistoryItem = {
    currentFileName: string;
    currentFileUrl: string;
    uploadedAt: string;
    uploadedBy: string;
};

export const getCurrentPdf = async (): Promise<PdfHistoryItem | null> => {
    try {
        const query = await getDoc(
            doc(firestoreInstance(), 'instructions_for_use_documents', 'clinicians')
        );
        const data = query.data();

        return {
            currentFileName: data?.current_file_name,
            currentFileUrl: data?.current_file_url,
            uploadedAt: data?.uploaded_at,
            uploadedBy: data?.uploaded_by
        };
    } catch (e: unknown) {
        if (e instanceof Error) {
            console.error(e.message);
            return null;
        } else {
            console.error('An unknown error occurred:', e);
            return null;
        }
    }
};
